import { ArrowUpRight } from "lucide-react";
import { useLang } from "./LangContext";
import { MaskLine, Reveal } from "./Reveal";
import { EMAIL } from "@/data/content";

export default function ForBrands() {
  const { t } = useLang();

  return (
    <section
      data-testid="brands-section"
      className="border-t border-border px-6 py-28 md:px-12 md:py-44"
    >
      <div className="grid grid-cols-1 gap-14 md:grid-cols-12">
        <div className="md:col-span-3">
          <span className="label">07 — For brands</span>
        </div>
        <div className="md:col-span-9">
          <h2 className="font-display text-4xl font-medium leading-[0.95] tracking-tight md:text-6xl lg:text-7xl">
            {t.brands.headline.map((line, i) => (
              <MaskLine key={i} delay={i * 0.08}>
                {line}
              </MaskLine>
            ))}
          </h2>
          <Reveal delay={0.15}>
            <p className="mt-10 max-w-2xl text-lg leading-relaxed text-muted-foreground md:text-xl">
              {t.brands.text}
            </p>
          </Reveal>

          <Reveal delay={0.25}>
            <div className="mt-14 flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between">
              <a
                href={`mailto:${EMAIL}?subject=MIDLOWS%20brand%20partnership`}
                data-testid="brands-cta"
                data-cursor="hover"
                className="group inline-flex items-center gap-3 font-display text-3xl font-medium tracking-tight md:text-5xl"
              >
                <span className="transition-colors duration-300 group-hover:text-accent">
                  {t.brands.cta}
                </span>
                <ArrowUpRight className="h-8 w-8 transition-transform duration-300 group-hover:translate-x-2 group-hover:-translate-y-2 group-hover:text-accent md:h-12 md:w-12" />
              </a>
              <a
                href={`mailto:${EMAIL}`}
                data-testid="brands-email"
                data-cursor="hover"
                className="font-mono text-sm uppercase tracking-[0.15em] text-muted-foreground underline-offset-4 transition-colors duration-300 hover:text-foreground hover:underline"
              >
                {EMAIL}
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
